/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExperienceDayPagedData } from '../../models/experience-day-paged-data';

export interface GetExperienceDays$Params {
  PageNumber?: number;
  PageSize?: number;
}

export function getExperienceDays(http: HttpClient, rootUrl: string, params?: GetExperienceDays$Params, context?: HttpContext): Observable<StrictHttpResponse<ExperienceDayPagedData>> {
  const rb = new RequestBuilder(rootUrl, getExperienceDays.PATH, 'get');
  if (params) {
    rb.query('PageNumber', params.PageNumber, {});
    rb.query('PageSize', params.PageSize, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExperienceDayPagedData>;
    })
  );
}

getExperienceDays.PATH = '/experienceday';
